export default __webpack_public_path__ + "static/media/anatomy-research-models.24256912.jpg";